import React from 'react';
import { Check, Zap } from 'lucide-react';
import { Button } from './ui/button';
import { PARTNER_PACKAGES } from '../config/packages';

const PricingCards = ({ onSelectPackage }) => {
  return (
    <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
      {PARTNER_PACKAGES.map((pkg) => (
        <button
          key={pkg.id}
          onClick={() => onSelectPackage(pkg.id)}
          className={`relative bg-white rounded-2xl p-8 border-2 transition-all hover:shadow-xl cursor-pointer w-full text-left ${
            pkg.popular
              ? 'border-brand-green shadow-lg scale-105'
              : 'border-gray-200 hover:border-brand-green/30'
          }`}
        >
          {/* Popular Badge */}
          {pkg.popular && (
            <div className="absolute -top-4 left-1/2 -translate-x-1/2">
              <div className="px-4 py-1.5 bg-brand-green text-white text-sm font-semibold rounded-full flex items-center gap-1 shadow-lg">
                <Zap className="h-4 w-4" />
                {pkg.badge}
              </div>
            </div>
          )}

          {/* Header */}
          <div className="text-center mb-6 mt-2">
            <h3 className="text-2xl font-bold text-gray-900 mb-2">{pkg.name}</h3>
            <p className="text-sm text-gray-600 mb-4">{pkg.description}</p>
            <div className="mb-4">
              <div className="text-3xl font-bold text-gray-900">
                {pkg.priceDisplay} / Monat
              </div>
            </div>
            <div className="inline-block px-4 py-2 bg-brand-green/10 text-brand-green font-semibold rounded-lg">
              {pkg.commissionDisplay} Provision
            </div>
          </div>

          {/* Features */}
          <ul className="space-y-3 mb-8">
            {pkg.features.map((feature, idx) => (
              <li key={idx} className="flex items-start gap-3 text-sm text-gray-700">
                <Check className="h-5 w-5 text-brand-green flex-shrink-0 mt-0.5" />
                <span>{feature}</span>
              </li>
            ))}
          </ul>

          {/* CTA */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              onSelectPackage(pkg.id);
            }}
            className="w-full bg-brand-green hover:bg-brand-green-dark text-white font-semibold py-3 rounded-xl transition-colors"
          >
            Abo starten
          </button>
        </button>
      ))}
    </div>
  );
};

export default PricingCards;
